import React from 'react'
import classnames from 'classnames'

import {TImage} from '../../../static-shared'
import {Button, ImageComponent, Link, Text} from '../../components'
import {MD} from '../../components/Markdown'

import styles from './styles.module.css'

export type TPromoCardProps = {
  text: string
  caption?: string
  image: TImage
  link?: string
  onClick?: () => void
  isInBlock?: boolean
}

const MAX_TEXT_LENGTH = 68

export function PromoCard({text, caption = 'Промо', image, link = '', onClick, isInBlock}: TPromoCardProps) {
  const promoText = text.length > MAX_TEXT_LENGTH ? text.slice(0, MAX_TEXT_LENGTH) + '...' : text

  return (
    <Link
      href={link}
      underline={false}
      className={classnames(styles.promoContainer, {[styles.block]: isInBlock})}
      onClick={e => {
        if (onClick) {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <Text tag="p" kind="caption" className={styles.caption}>
        {caption}
      </Text>
      <div className={styles.textContainer}>
        <Text tag="p" kind="title" className={classnames(styles.text, styles.desktop)} color="whiteTotal">
          <MD source={promoText} />
        </Text>
        <Text tag="p" kind="label" className={classnames(styles.text, styles.mobile)} color="whiteTotal">
          <MD source={promoText} />
        </Text>
        <Button
          className={styles.button}
          icon="arrow"
          iconPosition="right"
          iconSize="m"
          shape="rounded"
          size="s"
          variant="secondary"
        />
      </div>
      <div className={styles.imageContainer}>
        <ImageComponent {...image} className={styles.image} />
      </div>
      <div className={styles.backgroundFilter} />
    </Link>
  )
}
